const url = '/monitor/userStat';

// 전체 조회
export const getInstallStatAll = async (conn, data) => {
  const { userId, userTerm, rgnCode, dongCode, meainStatCode, bizType, dangerElderYn } = data;
  const config = {
    params: {
      userId: userId,
      // userTerm: userTerm,
      rgnCode: rgnCode,
      dongCode: dongCode,
      meainStatCode: meainStatCode,
      bizType: bizType,
      dangerElderYn: dangerElderYn,
    },
  };

  const response = await conn.get(url + '/list', config);
  return response;
};

export const getLtByDongCode = async (conn, dongCode) => {
  const result = await conn.get("/area", {
    params: {
      dongCode: dongCode,
    },
  });
  return result;
};